<script setup>
import {useMagicKeys} from "@vueuse/core";
import {watch} from "vue";
import {useRouter} from "vue-router";
import { onMounted } from 'vue';
const router = useRouter();
const keys=useMagicKeys();
const shortcuts= {
    home: keys['alt+h'],
    pos: keys['Alt+p'],
    newProduct: keys['Alt+n'],
    purchaseBill: keys['Alt+b'],
    salesInvoice: keys['Alt+i'],
    voucherEntry: keys['Alt+v'],
    newCustomer: keys['Alt+c'],
    newSupplier: keys['Alt+s'],
}

onMounted(() => {
   const channel = new BroadcastChannel("site-channel");

    channel.onmessage = (e) => {
        if (e.data === "reload") {
            location.reload();
        }
    };
});

watch(shortcuts.pos, (pressed) => {
    if (pressed) {
        router.push('/pos/pointOfSale/')
    }
})
watch(shortcuts.newProduct, (pressed) => {
    if (pressed) {
        router.push('/product/createEdit/LTE=')
    }
})
watch(shortcuts.purchaseBill, (pressed) => {
    if (pressed) {
        router.push('/purchase/purchaseBill/createEdit')
    }
})
watch(shortcuts.salesInvoice, (pressed) => {
    if (pressed) {
        router.push('/sale/salesInvoice')
    }
})
watch(shortcuts.voucherEntry, (pressed) => {
    if (pressed) {
        router.push('/account/voucher')
    }
})
watch(shortcuts.newCustomer, (pressed) => {
    if (pressed) {
        router.push('/sale/customer')
    }
})
watch(shortcuts.newSupplier, (pressed) => {
    if (pressed) {
        router.push('/purchase/supplier')
    }
})
watch(shortcuts.home, (pressed) => {
    if (pressed) {
        router.push('/')
    }
})
</script>

<template>
  <router-view />
</template>

<style scoped></style>
